import { CardHeader as MuiCardHeader, type CardHeaderProps as MuiCardHeaderProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiCardHeaderProps, 'slots' | 'disableTypography'>>;

export function CardHeader(props: Props) {
  return <MuiCardHeader {...props} />;
}

export type { Props as CardHeaderProps };
